import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

export interface IFormCanDeactivateGuard {
  canLeaveForm(): boolean | Observable<boolean> | Promise<boolean>;
}

@Injectable()
export class FormCanDeactivateGuard
  implements CanDeactivate<IFormCanDeactivateGuard>
{
  canDeactivate(
    component: IFormCanDeactivateGuard,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return component.canLeaveForm();
  }
}
